export default __webpack_public_path__ + "static/media/04d.d90800fe.png";